export const manufacturerCreateData = {
  loading: false,
  error: false,
  success: false,
  vendor_id: null,
  designations: [],
  headquaters: [],
  divisions: [],
};
